
import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    watch,
    getCurrentInstance,
} from "vue";
import TUIConversationList from "./components/list";
import { caculateTimeago, isArrayEqual } from "../utils";
import {
    handleAvatar,
    handleName,
    handleShowLastMessage,
    handleAt,
} from "../TUIChat/utils/utils";
import { useStore } from "vuex";

// import mitt from "mitt";
// const mitts = mitt();
import emitter from "@/utils/emitter";
const instance = getCurrentInstance();

// console.log("emit1-TUICOn");

const TUIConversation = defineComponent({
    name: "TUIConversation",

    components: {
        TUIConversationList,
    },

    setup(props: any, ctx: any) {
        const TUIServer: any = TUIConversation?.TUIServer;
        const VuexStore = useStore && useStore();

        const data = reactive({
            currentConversationID: "",
            conversationData: {
                list: [],
                handleItemAvator: (item: any) => handleAvatar(item),
                handleItemName: (item: any) => handleName(item),
                handleShowAt: (item: any) => handleAt(item),
                handleShowMessage: (item: any) => handleShowLastMessage(item),
                handleItemTime: (time: number) => {
                    if (time > 0) {
                        return caculateTimeago(time * 1000);
                    }
                    return "";
                },
            },
            userIDList: new Set(),
            netWork: "",
            env: TUIServer.TUICore.TUIEnv,
            displayOnlineStatus: VuexStore?.state?.displayOnlineStatus,
            userStatusList:
                TUIServer.TUICore.TUIServer.TUIContact?.currentStore
                    ?.userStatusList,
        });

        TUIServer.bind(data);

        TUIConversationList.TUIServer = TUIServer;
        watch(
            () => data.currentConversationID,
            (newVal: any, oldVal: any) => {
                ctx.emit("current", newVal);
                // console.log(newVal, "newVal");
            },
            {
                deep: true,
            }
        );
        // console.log(data.currentConversationID,'new');

        watch(
            () => VuexStore?.state?.displayOnlineStatus,
            async (newVal: any, oldVal: any) => {
                if (newVal === oldVal) return;
                data.displayOnlineStatus = newVal;
                TUIServer.TUICore.TUIServer.TUIContact.handleUserStatus(
                    data.displayOnlineStatus,
                    [...data.userIDList]
                );
                data.userStatusList =
                    TUIServer.TUICore.TUIServer.TUIContact?.currentStore?.userStatusList;
            }
        );

        watch(
            () => [...data.userIDList],
            async (newVal: any, oldVal: any) => {
                if (isArrayEqual(newVal, oldVal)) return;
                TUIServer.TUICore.TUIServer.TUIContact.handleUserStatus(
                    data.displayOnlineStatus,
                    [...data.userIDList]
                );
            },

            {
                deep: true,
            }
        );

        const isNetwork = computed(() => {
            const disconnected =
                data.netWork ===
                TUIServer.TUICore.TIM.TYPES.NET_STATE_DISCONNECTED;
            const connecting =
                data.netWork ===
                TUIServer.TUICore.TIM.TYPES.NET_STATE_CONNECTING;
            return disconnected || connecting;
        });

        const handleCurrentConversation = (value: any) => {
            TUIServer.handleCurrentConversation(value);
            // console.log(value.userProfile.userID,'item-TUIConaaaaaa');
            // 拿到本地的数据 和当前点击的数据 value.userProfile.userID
            let arr = JSON.parse(localStorage.getItem("allParams") || "[]");

            var IsParams = "";
            IsParams = arr.find((item: any) => {
                return item?.indexOf(value.userProfile.userID) > 0;
            });
            console.log(IsParams, "IsParams-TUICOn");
            console.log(IsParams === undefined);

            // if (IsParams !== undefined) {
            emitter.emit("openAdd", IsParams);
            // }
        };
        return {
            ...toRefs(data),
            handleCurrentConversation,
            isNetwork,
        };
    },
});
export default TUIConversation;
